exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-select {\n  width: 100%;\n  max-width: 300px; }\n  .search-select .ant-select-selection-selected-value {\n    color: #33404d !important; }\n  .search-select .ant-select-selection {\n    border: 1px solid #979797; }\n\n.ant-select-dropdown-menu .view-option {\n  font-size: 10px;\n  display: inline;\n  color: #33404d !important; }\n\n.ant-select-dropdown-menu .view-null-option {\n  font-size: 10px;\n  display: inline;\n  color: #33404d !important; }\n\n.ant-select-dropdown-menu .ant-spin {\n  margin-bottom: -3px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/AnalyticsMetric/components/Dropdown/SearchSelect/style.scss
// module id = 990
// module chunks = 0